import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

import { PostHogProvider } from 'posthog-js/react';
import { posthogConfig } from './config/posthog';

const options = {
  api_host: posthogConfig.apiHost,
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider apiKey={posthogConfig.apiKey} options={options}>
      <App />
    </PostHogProvider>
  </React.StrictMode>
);
